"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePdfEnum = void 0;
var InvoicePdfEnum;
(function (InvoicePdfEnum) {
    InvoicePdfEnum[InvoicePdfEnum["EDITED"] = 0] = "EDITED";
    InvoicePdfEnum[InvoicePdfEnum["ORIGINAL"] = 1] = "ORIGINAL";
})(InvoicePdfEnum || (exports.InvoicePdfEnum = InvoicePdfEnum = {}));
